import React from "react";
import { Circles, ColorRing } from "react-loader-spinner";

const Loader = ({ Height }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center w-100 "
      style={{ height: Height }}
    >
      <Circles
        height="80"
        width="80"
        color="#10b981"
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export const LoaderNeo = ({ height, width, message }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ width: "fit-content", padding:"10px", gap:"5px" }}
    >
      <ColorRing
        height={`${height}`}
        width={`${width}`}
        colors={['#000',"#000","#000","#000","#000"]}
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
      <p style={{margin:"0px"}}>{message || "Loading"}</p>
    </div>
  );
};



export default Loader;
